import React from 'react';
import PropTypes from 'prop-types';

const ShippingInfoBlock = ({ checkout: { shipping, shippingGroups } }) => (
  <div className="mt-8 flex flex-wrap sm:justify-end">
    <div className="min-w-full sm:min-w-[170px] first:mb-[2em] first:sm:mb-0 first:sm:mr-2.5">
      <div className="text-base font-bold [border-bottom:1px_solid_#e5e5e5] pb-2 mb-4">
        Shipping Info
      </div>
      <div className="text-sm">
        {`${shipping.first_name} ${shipping.last_name}`}
        <br />
        {shipping.address}
        <br />
        {shipping.apartment && (
          <>
            {shipping.apartment}
            <br />
          </>
        )}
        {`${shipping.city}, ${shipping.state} ${shipping.zipcode}`}
        {shipping.shipping_email && (
          <>
            <br />
            {shipping.shipping_email}
          </>
        )}
      </div>
    </div>
    <div className="min-w-full sm:min-w-[170px] first:mb-[2em] first:sm:mb-0 first:sm:mr-2.5">
      <div className="text-base font-bold [border-bottom:1px_solid_#e5e5e5] pb-2 mb-4">
        Delivery
      </div>
      <div className="text-sm">
        Estimated Delivery :
        <br />
        {shippingGroups.length === 1 &&
          shippingGroups[0]?.delivery_dates?.etaDelivery?.short_format}
        {shippingGroups.length > 1 &&
          shippingGroups.map((shippinggroup, index) => (
            <>
              {`Package ${index + 1}:
                ${shippinggroup?.delivery_dates?.etaDelivery?.short_format}`}
              <br />
            </>
          ))}
      </div>
    </div>
  </div>
);

ShippingInfoBlock.propTypes = {
  checkout: PropTypes.shape({
    shipping: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      address: PropTypes.string,
      apartment: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipcode: PropTypes.string,
      shipping_email: PropTypes.string,
    }),
    shippingGroups: PropTypes.arrayOf(
      PropTypes.shape({
        delivery_dates: PropTypes.shape({
          etaDelivery: PropTypes.shape({
            short_format: PropTypes.string,
          }),
        }),
      })
    ),
  }),
};

export default ShippingInfoBlock;
